module.exports = __webpack_public_path__ + "4c300d5fc001685e3600a21991f1e380.jpg";